import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./UploadProgressOverlay.css";

const UploadProgressOverlay = ({ progress }) => {
  const percentage = Number.isFinite(progress) ? Math.min(100, Math.max(0, Math.round(progress))) : 0;
  return (
    <div className="uploading-overlay">
      <div className="uploading-content">
        <p className="uploading-eyebrow">SAVING YOUR MEMORIES</p>
        <div className="uploading-ring" role="progressbar" aria-label="Photo upload progress" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percentage}>
        <div aria-hidden="true">
        <CircularProgressbar
          value={percentage}
          text={`${percentage}%`}
          styles={buildStyles({
            pathTransitionDuration: 0.6,
            pathColor: "#ff8c00",
            textColor: "#ffffff",
            trailColor: "#3c3229",
            textSize: "22px",
          })}
          strokeWidth={5}
        />
        </div>
        </div>
        <h2 className="uploading-text" role="status">{percentage === 100 ? "Finishing up…" : "Uploading your photos…"}</h2>
        <p className="uploading-help">Keep this screen open while we save your photos to the event.</p>
      </div>
    </div>
  );
};

export default UploadProgressOverlay;
